import { ViewChild, Inject } from '@angular/core';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { UserWellsService } from '../user-wells.service';

import { DailyDateRangeSelectorComponent } from '../daily-date-range-selector/daily-date-range-selector.component';

@Component({
  selector: 'app-delete-injection-dialog',
  templateUrl: './delete-injection-dialog.component.html',
  styleUrls: ['./delete-injection-dialog.component.css']
})
export class DeleteInjectionDialogComponent implements OnInit {

  dateBoundsSelectionForm: FormGroup;

  @ViewChild(DailyDateRangeSelectorComponent) dateRangeSelector: DailyDateRangeSelectorComponent;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<DailyDateRangeSelectorComponent>,
    public userWellsService: UserWellsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {

    //Create the date bounds form - this is the formgroup for the first page
    this.dateBoundsSelectionForm = this.formBuilder.group({
    });
  }

  ngAfterViewInit(): void {
    this.dateBoundsSelectionForm.addControl('dateBoundsSelectionForm', this.dateRangeSelector.dateBoundsSelectionForm);
  }

  deleteClicked(): void {
    var value = this.dateBoundsSelectionForm.value;

    var beginDate = value.dateBoundsSelectionForm.BeginDate;
    var endDate = value.dateBoundsSelectionForm.EndDate;

    //If the begin date is less than the end date, switch them around.
    if (beginDate > endDate) {
      var tempDate = beginDate;
      beginDate = endDate;
      endDate = tempDate;
    }

    var returnDate = {
      beginDate: beginDate,
      endDate: endDate
    };
    
    this.dialogRef.close(returnDate);
  }

}
